
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name finance.vckkcat.factory:KkcatHelper
   *
   * @description
   *
   */
  angular
    .module('finance.vckkcat')
    .factory('KkcatHelper', KkcatHelper);
  
  
  KkcatHelper.$inject = ['Kkcat', '$uibModal', '$log', 'Rlog'];
  
  function KkcatHelper(Kkcat, $uibModal, $log, Rlog) {
    let KkcatHelperBase = {};
    
    KkcatHelperBase.editKkcat = editKkcat;
    KkcatHelperBase.addKkcat = addKkcat;
    
    
    function addKkcat(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><kkcatform kkcat="vm.kkcat" parentsave="vm.childsave(kkcat)" oncancel="vm.cancel()"></kkcatnew></div>',
        controllerAs: 'kkcataCtrl',
        controller: ['kkcat', function () {
          let vm = this;
          vm.kkcat = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(kkcat) {
            Kkcat.$create(kkcat).$then(function (newkkcat) {
              vm.created = true;
              success(newkkcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ kkcat-helper.addKkcat: ', err);
              Rlog.error('vcutils.kkcat', 'kkcat-helper.addKkcat', 'Creation of new SV failed: ', {error: err, kkcat: kkcat});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          kkcat: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editKkcat(lkkcat) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><kkcatform kkcat="kkcateCtrl.kkcat" parentsave="kkcateCtrl.childsave(kkcat)" oncancel="kkcateCtrl.cancel()"></kkcatform></div>',
        controllerAs: 'kkcateCtrl',
        controller: ['kkcat', function (skkcat) {
          let vm = this;
          vm.kkcat = skkcat;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(kkcat) {
            // vm.kkcat = angular.copy(kkcat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in kkcat) {
              if (kkcat.hasOwnProperty(key)) {
                vm.kkcat[key] = kkcat[key];
              }
            }
            
            if (vm.kkcat.$hasPendingActions()) {
              vm.kkcat.$cancel();
              vm.kkcat.$save();
              cancel();
            }
            else {
              vm.kkcat.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          kkcat: function () {
            return lkkcat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return KkcatHelperBase;
  }
}());
